export default __webpack_public_path__ + "static/media/MVRDV.37313d9d.jpg";